import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_WORK_ORDERS_UPLOADED_IMAGE = 'FETCH_WORK_ORDERS_UPLOADED_IMAGE'
export const RECEIVE_WORK_ORDERS_UPLOADED_IMAGE = 'RECEIVE_WORK_ORDERS_UPLOADED_IMAGE'
export const FAILED_WORK_ORDERS_UPLOADED_IMAGE = 'FAILED_WORK_ORDERS_UPLOADED_IMAGE'

export function fetchWorkOrdersUploadedImage(_id_delivery_order, _id_work_order){
    // var loginCreds = JSON.parse(window.atob(localStorage.Automalt));
    var auth = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJlbWFpbCI6ImtyaXN0aWFudG9rZWx2aW5AbGl2ZS5jb20iLCJuYW1lIjoiS2VsdmluIiwiY29tcGFueSI6NCwiY29tcGFueV9uYW1lIjoiUFQgRGlhbW9uZCBNaXRyYSBQZXJzYWRhIExlc3RhcmkiLCJjb21wYW55X3Bob25lIjoiNjI4MjEzNzYzNTE3NiIsInJvbGVzX2lkIjo1LCJyb2xlcyI6Ik1hc3RlciBLZXkiLCJpYXQiOjE2MDQ5NDQ1NDQsImV4cCI6MTkyMDMwNDU0NH0.DZ_rlxoCNL9t75elrxYhcy9v7bWOFvd20tAmmMmw2Tk"
    // console.log(auth)
    return async (dispatch, getState) => {
        dispatch({type: FETCH_WORK_ORDERS_UPLOADED_IMAGE});
        axios({
            method: 'post',
            url: API_LINKS.WORK_ORDER_UPLOADED_IMAGE_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id_delivery_order: _id_delivery_order,
                id_work_order: _id_work_order
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_WORK_ORDERS_UPLOADED_IMAGE,
                payload: response.data.result,
                id_work_order: _id_work_order
            })
        })
        .catch(function(error){
            console.log(error)
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_WORK_ORDERS_UPLOADED_IMAGE
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_WORK_ORDERS_UPLOADED_IMAGE
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_WORK_ORDERS_UPLOADED_IMAGE
                    })
                    // return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_WORK_ORDERS_UPLOADED_IMAGE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_WORK_ORDERS_UPLOADED_IMAGE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_WORK_ORDERS_UPLOADED_IMAGE
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}

export const FETCH_WORK_ORDERS_DRIVER_LIST = 'FETCH_WORK_ORDERS_DRIVER_LIST'
export const RECEIVE_WORK_ORDERS_DRIVER_LIST = 'RECEIVE_WORK_ORDERS_DRIVER_LIST'
export const FAILED_WORK_ORDERS_DRIVER_LIST = 'FAILED_WORK_ORDERS_DRIVER_LIST'

export function fetchWorkOrdersDriverList(auth){

    return async (dispatch, getState) => {
        dispatch({type: FETCH_WORK_ORDERS_DRIVER_LIST});
        axios({
            method: 'post',
            url: API_LINKS.WORK_ORDER_LIST_FOR_PROOF,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_WORK_ORDERS_DRIVER_LIST,
                payload: response.data.result,
            })
        })
        .catch(function(error){
            console.log(error)
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_WORK_ORDERS_DRIVER_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_WORK_ORDERS_DRIVER_LIST
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_WORK_ORDERS_DRIVER_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_WORK_ORDERS_DRIVER_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_WORK_ORDERS_DRIVER_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_WORK_ORDERS_DRIVER_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/aTransporter-WorkOrdersUpload.jsx